// import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
// import EditDeleteButton from "components/table/EditDeleteButton";
// import React from "react";
// import useToggleDrawer from "hooks/useToggleDrawer";
// import PermitDrawer from "components/drawer/PermitDrawer";
// import MainDrawer from "components/drawer/MainDrawer";
// import DeleteModal from "components/modal/DeleteModal";

// const PermitTable = ({
//   permit,
//   perpage,
//   currentPage,
//   hideDelete,
//   hideEdit,
// }) => {


//   console.log(permit,'here is the permit data, asdfasdfas dfa sdfa sdf')

//   const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
//   const permitsorted = [...(permit || [])].sort((a, b) =>
//     (a?.from_state_name || "").localeCompare(b?.from_state_name || "")
//   );


//   return (
//     <>
//       <DeleteModal id={serviceId} title={title} />

//       <MainDrawer>
//         <PermitDrawer id={serviceId} />
//       </MainDrawer>

//       <TableBody>
//         {permitsorted?.slice(0, perpage).map((data, index) => (
//           <React.Fragment key={data.id}>
//             {data["vehicle_type_id"].map((item, vehicleIndex) => (
//               <TableRow key={`${data.id}-${vehicleIndex}`}>
//                 {/* Display Sl.No., City, Start Date, and End Date only on the first row of each vehicle type group */}
//                 {vehicleIndex === 0 && (
//                   <>
//                     <TableCell
//                       className="text-sm text-center"
//                       rowSpan={data["vehicle_type_id"].length}
//                     >
//                       {(currentPage - 1) * perpage + index + 1}
//                     </TableCell>
//                     <TableCell
//                       className="text-sm text-center"
//                       rowSpan={data["vehicle_type_id"].length}
//                     >
//                       {data["from_state_name"]}
//                     </TableCell>

//                     <TableCell
//                       className="text-sm text-center"
//                       rowSpan={data["vehicle_type_id"].length}
//                     >
//                       {data["to_state_name"]}
//                     </TableCell>
//                   </>
//                 )}

//                 {/* Display Vehicle Type and Hike (%) for each entry */}
//                 <TableCell className="text-sm text-center">
//                   {data["vehicle_type_names"][item]}
//                 </TableCell>
//                 <TableCell className="text-sm text-center">
//                   {data["permit"][item]}
//                 </TableCell>

//                 {/* Display Actions column only on the first row of each grouped vehicle type */}
//                 {vehicleIndex === 0 && (
//                   <TableCell
//                     rowSpan={data["vehicle_type_id"].length}
//                     className="text-center"
//                   >
//                     <EditDeleteButton
//                       title={data["Permit"]}
//                       id={data.id}
//                       handleUpdate={handleUpdate}
//                       handleModalOpen={handleModalOpen}
//                       hideDelete={hideDelete}
//                       hideEdit={hideEdit}
//                     />
//                   </TableCell>
//                 )}
//               </TableRow>
//             ))}
//           </React.Fragment>
//         ))}
//       </TableBody>
//     </>
//   );
// };

// export default PermitTable;




import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import PermitDrawer from "components/drawer/PermitDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

const PermitTable = ({
  permit,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const {
    title,
    serviceId,
    handleModalOpen,
    handleUpdate,
  } = useToggleDrawer();

  // const permitsorted = [...(permit || [])].sort((a, b) =>
  //   (a?.from_state_name || "").localeCompare(
  //     b?.from_state_name || ""
  //   )
  // );

  const permitsorted = permit || []

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <PermitDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {permitsorted
          ?.slice(0, perpage)
          ?.map((data, index) => {
            const vehicleTypes = data?.vehicle_type_id || [];
            const rowSpanCount = vehicleTypes.length;

            if (rowSpanCount === 0) {
              return (
                <TableRow key={data?.id}>
                  <TableCell className="text-sm text-center">
                    {(currentPage - 1) * perpage + index + 1}
                  </TableCell>

                  <TableCell className="text-sm text-center">
                    {data?.from_state_name || "-"}
                  </TableCell>

                  <TableCell className="text-sm text-center">
                    {data?.to_state_name || "-"}
                  </TableCell>

                  <TableCell className="text-sm text-center">
                    -
                  </TableCell>

                  <TableCell className="text-sm text-center">
                    -
                  </TableCell>

                  <TableCell className="text-center">
                    <EditDeleteButton
                      title={data?.Permit}
                      id={data?.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </TableCell>
                </TableRow>
              );
            }

            return vehicleTypes.map((item, vehicleIndex) => (
              <TableRow key={`${data?.id}-${item}-${vehicleIndex}`}>
                {vehicleIndex === 0 && (
                  <>
                    <TableCell
                      className="text-sm text-center"
                      rowSpan={rowSpanCount}
                    >
                      {(currentPage - 1) * perpage + index + 1}
                    </TableCell>

                    <TableCell
                      className="text-sm text-center"
                      rowSpan={rowSpanCount}
                    >
                      {data?.from_state_name || "-"}
                    </TableCell>

                    <TableCell
                      className="text-sm text-center"
                      rowSpan={rowSpanCount}
                    >
                      {data?.to_state_name || "-"}
                    </TableCell>
                  </>
                )}

                <TableCell className="text-sm text-center">
                  {data?.vehicle_type_names?.[item] || "-"}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data?.permit?.[item] || 0}
                </TableCell>

                {vehicleIndex === 0 && (
                  <TableCell
                    rowSpan={rowSpanCount}
                    className="text-center"
                  >
                    <EditDeleteButton
                      title={data?.Permit}
                      id={data?.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </TableCell>
                )}
              </TableRow>
            ));
          })}
      </TableBody>
    </>
  );
};

export default PermitTable;